import { ActionReducerMap, MetaReducer } from '@ngrx/store';
import { environment } from '../../environments/environment';

// Empty state for ROOT-itself
// this is intentional
export const reducers: ActionReducerMap<{}> = {};

export const metaReducers: MetaReducer<{}>[] = !environment.production ? [] : [];
